import type { ResourceEndpoints } from '../core'

/** Every URL of the template-versions API. */
export const templateVersionsEndpoints = {
  collection: '/api/v1/template-versions',
  item: (id: string) => `/api/v1/template-versions/${encodeURIComponent(id)}`,
  /** Makes variations of a project's approved template: one call, one variation, one background task. */
  generateVariations: (projectId: string) => `/api/projects/${encodeURIComponent(projectId)}/templates/generate-variations`,
} satisfies ResourceEndpoints & { generateVariations: (projectId: string) => string }
